import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { StyledTableBodyCell } from "./cells/cell.styles";
import { Colors } from "theme/colors";

interface BodyRowProps {
  $selected: boolean;
}

export const StyledTableRow = styled.div`
  display: table-row;
`;

export const StyledTableBodyRow = styled(StyledTableRow)<BodyRowProps>`
  ${(props) =>
    props.$selected &&
    css`
      & ${StyledTableBodyCell} {
        background-color: ${Colors.LIGHT_BLUE} !important;
      }
    `}
`;

export const StyledTableHeaderRow = styled(StyledTableRow)``;
